(function () {
  'use strict';

  var app = angular.module('lif', ['ngAnimate', 'checklist-model', 'lif.filters', 'lif.controllers', 'ngFileUpload', 'datetime', 'ui.sortable']);
  app.constant('constants', {
    GroupEventType: {
      'Default': 0,
      'Member': 1,
      'Message': 2,
      'File': 3,
      'Link': 4,
      'MeetingsFile': 5,
      'CatalogStructureWithFile': 6
    },
    Action: {
      'Delete': 0,
      'Add': 1,
      'Shoutout': 2
    }
  });
  angular.module('lif.filters', []);
  angular.module('lif.services', []);
  angular.module('lif.controllers', ['lif.services']);
  app.run(['$rootScope', function ($rootScope) {
    FastClick.attach(document.body);
  }]);
})();